import "client_portal/public/js/fenris-canopy-lookup/canopy-connect.js";
import "client_portal/public/js/fenris-canopy-lookup/base.js";